/* eslint-disable no-param-reassign */
export const reorder = <T>(
  list: T[],
  startIndex: number,
  endIndex: number,
): T[] => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

// range(4) returns [0, 1, 2, 3],
// range(3,6) returns [3, 4, 5],
// range(0,10,2) returns [0, 2, 4, 6, 8],
// range(10,0,-1) returns [10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
// range(8,2,-2) returns [8, 6, 4],
// range(8,2) returns [],
// range(8,2,2) returns [],
// range(1,5,-1) returns [],
// range(1,5,-2) returns [],
export const range = (start: number, stop: number, step?: number): number[] => {
  if (typeof stop === 'undefined') {
    // one param defined
    stop = start;
    start = 0;
  }

  if (typeof step === 'undefined') {
    step = 1;
  }

  if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
    return [];
  }

  const result = [];
  for (let i = start; step > 0 ? i < stop : i > stop; i += step) {
    result.push(i);
  }

  return result;
};

export const addLeadingZeros = (num: number, totalLength: number): string => {
  return String(num).padStart(totalLength, '0');
};
